/* prettier-ignore */
const messages = {
  en: {
    product_location: 'In Stock: Aisle 9, Shelf B2',
    digital_advisor: 'Digital Beauty Advisor',
    build_skin_profile: 'Build Skin Profile',
    take_selfie: 'Take Selfie',
    see_skin_analysis: 'See Skin Analysis',
    get_personal_advice: 'Get Personal Advice',
    get_product_recommendations: 'Get Product Recommendations',
    start_over: 'Start Over',
    uv_index: 'UV Index',
    humidity: 'Humidity',
    pollution: 'Pollution',
    male: 'male',
    female: 'female',
    remove_glasses: 'Remove Glasses',
    pull_back_hair: 'Pull Back Hair',
    look_at_the_camera: 'Look at the Camera',
    tap_take_picture: 'Tap anywhere on the screen to take the picture',
    cancel: 'Cancel',
    continue: 'Continue',
    uploading_selfie: 'Uploading and Analysing',
    activating_camera: 'Activating camera',
    error_opening_camera: 'Error opening camera',
    back: 'Back',
    icon_darkcircles: 'Dark circles',
    icon_eyebags: 'Eye bags',
    icon_eyecolor: 'Eye color',
    icon_pigmentvariation: 'Pigment Variation',
    icon_radiance: 'Radiance',
    icon_shape: 'Face shape',
    icon_undertone: 'Undertone',
    icon_wrinkleslines: 'Wrinkles & Lines',
    icon_skintoneColor: 'Foundation',
    icon_skintone: 'Skintone',
    icon_redness: 'Redness',
    icon_texture: 'Texture',
    icon_skin_shine: 'Skin Shine',
    icon_acne: 'Acne',
    range_none: 'none',
    range_low: 'low',
    range_medium: 'medium',
    range_high: 'high',
    loading_products: 'Loading products',
    no_products: 'No products available',
    light_tone: 'Light',
    fair_tone: 'Fair',
    medium_tone: 'Medium',
    olive_tone: 'Olive',
    brown_tone: 'Brown',
    dark_brown_tone: 'Dark Brown',
    selfie_instructions_description_error:
      'Below are some suggestions that could help you improve the selfie and get better results',
    selfie_quality: 'Selfie Quality: ',
    selfie_quality_ok: 'Good',
    selfie_quality_poor: 'Please Retake',
    retake_selfie: 'Retake',
    capture_selfie: 'capture',
    checkout: 'Checkout',
    location_button: 'Your location:',
    geosuggest_placeholder: 'Search places:',
    tanning: 'Tanning',
    sun_protection: 'SPF',
    vegan: 'Vegan',
    organic: 'Organic',
    fragrance_free: 'Fragrance Free',
    paraben_free: 'Paraben Free',
    anti_age: 'Anti-aging',
    woman: 'Women',
    man: 'Men',
    cuperose: 'Couperose',
    rocasea: 'Rosacea',
    wrinkles: 'Wrinkles and fine lines',
    acne: 'Acne',
    eczema: 'Eczema',
    psoriasis: 'Psoriasis',
    hyperpigmentation: 'Hyperpigmentation',
    dull_tired: 'Dull skin',
    skin_brightening: 'Skin brightening',
    oilyness: 'Oiliness',
    skin_firming: 'Skin firming',
    normal_skin: 'Normal',
    dry_skin: 'Dry',
    oily_skin: 'Oily',
    sensitive_skin: 'Sensitive',
    idontknow_skin: 'Not sure',
    combination_skin: 'Combination',
    processing_image: 'Processing...',
    CV_MESSAGE_OK: 'Analysis OK.',
    CV_MESSAGE_Error: 'Unsuitable image.',
    CV_MESSAGE_Warning:
      'We were able to make findings from your image, however found that a better image would result in better findings. Here are some quality considerations we found from the image:',
    CV_MESSAGE_Warning_heading: 'Quality considerations',
    CV_CODE_100: 'Oops, this doesn\'t seem to be a color selfie. Please retake your selfie as a color-selfie',
    CV_CODE_101:
      'Oops, the resolution of the image was too small for us to analyze. We need an image of at least 600x600 pixels (any regular smartphone camera image will do)',
    CV_CODE_102:
      'Wow, now that was a selfie. But it seems that the proportions of the image are a bit distorted so we couldn\'t analyze it. Try taking another one with regular proportions.',
    CV_CODE_103:
      'Now that was quite a dark selfie. But not to worry, we’re still able to analyse it. Keep in mind if you’d like a more accurate analysis, you can always ',
    CV_CODE_104: 'Wow, now there\'s some light in that selfie. Unfortunately a bit too much direct light there.',
    CV_CODE_201: 'Hmm. We weren\'t able to find a face from your selfie. Can you try again?',
    CV_CODE_202: 'Multiple faces detected. Only the best fit face is analyzed',
    CV_CODE_203:
      'Hmm. We’re not quite sure there was a face in the selfie. But we were able to analyse what we believe to be a face ☺',
    CV_CODE_204: 'There doesn’t seem to be a face in the selfie. Please re-take your selfie',
    CV_CODE_205:
      'The picture is taken too close to the camera. As a result, the analysis might be inaccurate. Please take the picture further away from the camera.',
    CV_CODE_301: 'The detected face resolution is too small. Take a photo closer to your face.',
    CV_CODE_302: 'Face is too much tilted to the side. Try again please, but this time face straight to the camera.',
    CV_CODE_303: 'Face is possibly tilted to the side. Try again please, but this time face straight at the camera.',
    CV_CODE_304: 'Face is too much tilted down. Face straight at the camera.',
    CV_CODE_305: 'Face is possibly tilted down. Face straight at the camera.',
    CV_CODE_306: 'Face is possibly tilted up. Face straight at the camera.',
    CV_CODE_307: 'Image too dark at the face area. Increase exposure/light to the face.',
    CV_CODE_308: 'Image is overexposed at the face area. Find more diffuse lighting or reduce exposure.',
    CV_CODE_309: 'The face area blue channel is clipping (overexposed). Reduce exposure or adjust color balance.',
    CV_CODE_310: 'The face area green channel is clipping (overexposed). Reduce exposure or adjust color balance.',
    CV_CODE_311: 'The face area red channel is clipping (overexposed). Reduce exposure or adjust color balance.',
    CV_CODE_312: 'The face has asymmetric exposure to lighting. Find a spot with even lighting conditions',
    CV_CODE_313: 'The face area has hard shadows. Find more diffuse lighting.',
    CV_CODE_314: 'We noticed you might be wearing glasses. For better results, take a selfie without glasses.',
    CV_CODE_1000: 'You didn\'t define your skin tone. Please go back and select your skin tone to continue.',
    CV_CODE_1101:
      'Oops. Your eyes seem too closed for us to analyze their color. Please retake your selfie with your eyes open.',
    CV_CODE_1102:
      'Oops, it seems that your eyes may be a bit too closed. For better results, remember to keep your eyes open when taking a selfie.',
    CV_CODE_1111:
      'There seems to be some shadow directed at your eyes. We\'re not able to analyze your eye color. If you\'d like your eye color analyzed, please retake a selfie with better lighting directed at your eyes.',
    CV_CODE_1112:
      'There seems to be some shadow directed at your eyes, making it difficult for us to accurately analyze your eye color. If we we\'re mistaken about your eye color, take a new selfie with better lighting directed at your eyes',
    CV_CODE_1121:
      'Oops, your eye whites don\'t appear white in the selfie. We\'re not able to analyze your eye color. If you\'d like your eye color analyzed, please retake a selfie with better lighting directed at your eyes.',
    CV_CODE_1122:
      'Oops, your eye whites don\'t appear white in the selfie, making it difficult for us to analyze your eye color. If we we\'re mistaken about your eye color, take a new selfie with better lighting directed at your eyes.',
    CV_TYPE_eyebag: 'Eyebags',
    CV_TYPE_eyebag_descr_low:
      'After looking at your selfie, we discovered that eyebags are not a concern for you. We’ll take this into account when finding you the perfect skincare products.',
    CV_TYPE_eyebag_descr_med:
      'After looking at your selfie, we discovered that you have some signs of eyebags. We’ll take this into account when finding you the perfect skincare products.',
    CV_TYPE_eyebag_descr_high:
      'After looking at your selfie, we discovered that your eyes may appear tired. We’ll take this into account when finding you the perfect skincare products.',
    CV_TYPE_NEW_eyebag_descr_low:
      'Eyebags are not a concern for you. We’ll take this into account when finding you the perfect skincare products.',
    CV_TYPE_NEW_eyebag_descr_med:
      'You have some signs of eyebags. We’ll take this into account when finding you the perfect skincare products.',
    CV_TYPE_NEW_eyebag_descr_high:
      'Your eyes may appear tired. We’ll take this into account when finding you the perfect skincare products.',
    CV_TYPE_wrinkle: 'Facial Lines',
    CV_TYPE_wrinkle_descr_low:
      'After looking at your selfie, we discovered that your skin looks young and fresh. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',
    CV_TYPE_wrinkle_descr_med:
      'After looking at your selfie, we discovered that your skin is showing some signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',
    CV_TYPE_wrinkle_descr_high:
      'After looking at your selfie, we discovered that your skin is showing signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',
    CV_TYPE_NEW_wrinkle_descr_low:
      'Your skin looks young and fresh. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',
    CV_TYPE_NEW_wrinkle_descr_med:
      'Your skin is showing some signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',
    CV_TYPE_NEW_wrinkle_descr_high:
      'Your skin is showing signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',
    CV_TYPE_redness: 'Redness',
    CV_TYPE_redness_descr_low:
      'We noticed from your selfie that there is no significant redness on your skin. We will use this finding to find you the perfect skincare routine.',
    CV_TYPE_redness_descr_med:
      'We noticed from your selfie that there are some signs of redness on your skin. We will use this finding to find you the perfect skincare routine.',
    CV_TYPE_redness_descr_high:
      'We noticed from your selfie that your skin exhibits some redness. We will use this finding to find you the perfect skincare routine.',
    CV_TYPE_NEW_redness_descr_low:
      'There is no significant redness on your skin. We will use this finding to find you the perfect skincare routine.',
    CV_TYPE_NEW_redness_descr_med:
      'There are some signs of redness on your skin. We will use this finding to find you the perfect skincare routine.',
    CV_TYPE_NEW_redness_descr_high:
      'Your skin exhibits some redness. We will use this finding to find you the perfect skincare routine.',
    CV_TYPE_hyperpigmentation: 'Hyperpigmentation',
    CV_TYPE_NEW_hyperpigmentation_descr_high:
      'We discovered from your selfie that you have signs of pigment changes on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_hyperpigmentation_descr_med:
      'We discovered from your selfie that you have some signs of pigment changes on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_hyperpigmentation_descr_low:
      'We discovered from your selfie that pigment changes on your skin are not a consideration for you',
    HINTS_hyperpigmentation:
      'Pigment changes and hyperpigmentation are a common, harmless condition where parts of the skin becomes darker than the surrounding area. Using the proper skincare products meant to combat the effects of hyperpigmentation will help keep your skin nice and even-toned.',
    CV_TYPE_puffy_eyes: 'Puffy Eyes',
    CV_TYPE_NEW_puffy_eyes_descr_high:
      'We discovered from your selfie that you have signs of puffiness around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_puffy_eyes_descr_med:
      'We discovered from your selfie that you have some signs of puffiness around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_puffy_eyes_descr_low:
      'We discovered from your selfie that puffiness around your eyes is not a consideration for you',
    HINTS_puffy_eyes:
      'Puffiness around your eyes can be caused by many factors. Bad sleeping and eating habits and allergies can also contribute. Apart from drinking enough water, the right eye-products can reduce the appearance of puffy eyes and make your eyes look fresher.',
    CV_TYPE_dull_skin: 'Dull Skin',
    CV_TYPE_NEW_dull_skin_descr_high:
      'We discovered from your selfie that you have signs of dullness on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_dull_skin_descr_med:
      'We discovered from your selfie that you have some signs of dullness onyour skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_dull_skin_descr_low:
      'We discovered from your selfie that dullness of the skin is not a consideration for you',
    HINTS_dull_skin:
      'Dullness of the skin can be caused by extrenal influences such as pollution, dead skin cells or stress. A regular, targeted skincare routine will help you clear out dead skin cells and combat the impacts of the environment on your skin, making your skin look brighter.',
    CV_TYPE_sagging_skin: 'Sagging Skin',
    CV_TYPE_NEW_sagging_skin_descr_high:
      'We discovered from your selfie that you have signs of looseness on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_sagging_skin_descr_med:
      'We discovered from your selfie that you have some signs of looseness on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_sagging_skin_descr_low:
      'We discovered from your selfie that your skin looks firm and does not exhibit signs of looseness',
    HINTS_sagging_skin:
      'The most common cause of sagging skin is aging that causes a loss of collagen, making your skin seem looser than before. Although looseness of the skin is perfectly natural, specific skincare products have been developed to sustain collagen and firm the skin.',
    CV_TYPE_crows_feet: 'Crows Feet',
    CV_TYPE_NEW_crows_feet_descr_high:
      'We discovered from your selfie that you have signs of crow´s feet around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_crows_feet_descr_med:
      'We discovered from your selfie that you have some signs of crow´s feet around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_crows_feet_descr_low:
      'We discovered from your selfie that aging around your eyes is not an issue for you',
    HINTS_crows_feet:
      'Crow´s feet are a perfectly naturel part of maturing. Often worsened by squinting, crow´s feet can appear as early as in your thirties. Luckily, targeted skincare remedies to reduce the impact of crow´s exist.',
    CV_TYPE_visible_pores: 'Visible Pores',
    CV_TYPE_NEW_visible_pores_descr_high:
      'We discovered from your selfie that you have signs of enlarged pores on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_visible_pores_descr_med:
      'We discovered from your selfie that you have some signs of enlarged pores on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_visible_pores_descr_low:
      'We discovered from your selfie that enlarged pores on your skin are not a consideration for you',
    HINTS_visible_pores:
      'Enlarged pores are caused by excess oil production on your skin. Enlarged pores are likely to get clogged from impurities. Using skincare products to regularly help unclog your pores and reduce excess oil production will help in clearing your skin.',
    CV_TYPE_dark_circle: 'Dark circles',
    CV_TYPE_NEW_dark_circle_descr_high:
      'We discovered from your selfie that you have signs of dark circles under your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_dark_circle_descr_med:
      'We discovered from your selfie that you have some signs of dark circles under your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',
    CV_TYPE_NEW_dark_circle_descr_low:
      'We discovered from your selfie that tiredness of the eyes is not a concern for you',
    HINTS_dark_circle:
      'Dark circles under your eyes can be caused by a multitude of factors. Allergies, thinning of the skin, eczema or loss of collagen can all be contributing to the dark circles forming under your eyes. Although there is no miracle cure, specifically designed skincare products containing targeted dark circle reducing ingredients such as retinol can dramatically reduce the visibility of dark cirles.',
    show_cv_results: 'Analysis results',
    attribute_descriptions_anti_age: 'Helps your skin look young and rejuvinated',
    attribute_descriptions_eye_bag_reduction: 'Helps revitalize your undereye area ',
    attribute_descriptions_wrinkle_reduction: 'Reduces lines and wrinkles on your face',
    attribute_descriptions_redness_reduction: 'Reduces the redness visible on your skin',
    attribute_descriptions_sun_protection: 'Protects your skin from damage caused by the sun',
    attribute_descriptions_pollution_protection: 'Helps combat the effects of pollution',
    attribute_descriptions_dark_spot_reduction: 'Makes your skin look more even',
    attribute_descriptions_dry_skin_assist: 'Moisturizes your skin and helps prevent dryness',
    attribute_descriptions_dry_skin: 'Ideal for your dry skin',
    attribute_descriptions_combination_skin: 'Ideal for your combination skin',
    attribute_descriptions_oily_skin: 'Ideal for your oily skin',
    attribute_descriptions_sensitive_skin: 'Ideal for sensitive skin like yours',
    attribute_descriptions_normal_skin: 'Works very well for normal skin',
    attribute_descriptions_anti_acne: 'Helps fight signs of acne',
    attribute_descriptions_anti_eczema: 'Helps combat the visible effects of eczema',
    attribute_descriptions_anti_rosacea: 'Keeps rosacea under control',
    attribute_descriptions_anti_cuperose: 'Keeps the symptoms of cuperose at bay',
    crows_feet_ui: 'Crow\'s Feet',
    visible_pores_ui: 'Visible Pores',
    sagging_skin_ui: 'Sagging Skin',
    wrinkles_ui: 'Wrinkles And Fine Lines',
    puffy_eyes_ui: 'Puffy eyes',
    eyebags_ui: 'Eye bags',
    dark_circles_ui: 'Dark Circles Under Eyes',
    redness_ui: 'Redness',
    rocasea_ui: 'Rosacea',
    coperose_ui: 'Couperose',
    eczema_ui: 'Eczema',
    acne_ui: 'Acne',
    dull_skin_ui: 'Dull Skin',
    hyperpigmentation_ui: 'Hyperpigmentation',
    cuperose_ui: 'Couperose',
  },
};
export default messages;



// WEBPACK FOOTER //
// ./src/translations.js